import { Page } from '@/core/architecture'

import { ConsolePostCategoriesTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsolePostCategories Page
 * Implemented as a practical sample.
 */
export const ConsolePostCategories: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsolePostCategoriesTemplate state={state} {...actions} />
}
